module.exports = __webpack_public_path__ + "img/ill-home-services-desktop-applications.3ab6dbb0.svg";